// The prefix must start with OLK to avoid CTS(content transformation service) from appending x_ in front.
export const OUTLOOK_BEAUTIFIED_PREFIX = 'OLK_Beautified_';

export const ATTRIBUTE_CONTENTEDITABLE_NAME = 'contenteditable';
